export enum FeatureFlag {
  ReportingBulkApproval = 'reportingBulkApproval',
  ReportingQuality = 'reportingQuality',
  FlaCpcNfrAdditionalApprovers = 'flaCpcNfrAdditionalApprovers',
  PartnershipsOverviewPage = 'partnershipsOverviewPage',
  FlaCpcNfrParallelSigning = 'flaCpcNfrParallelSigning'
}
